export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name':
    'Pixartprinting S.p.A. a socio unico, Die Gesellschaft unterliegt der Leitung und Koordination der Cimpress plc',
  'privacy-policy': 'Datenschutzbestimmungen',
  'cookie-policy': 'Cookie policy',
  'informazioni-legali': 'Impressum',
}
